import React from 'react'
import { RealEstateCategory, SegmentationType, TransactionType } from '../../../../../@types/types'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { TENANT_GASTRONOMY_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import { tenantGastronomyRentSchema } from './tenantGastronomyRentSchema'
import {
  SCREEN_ADDRESS,
  SCREEN_CONNECTIONS,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import {
  gastronomyRentBasicInfoScreen,
  gastronomyRentOtherFacilitiesScreen,
} from '../../propertyOwner/gastronomy/propertyOwnerGastronomyRentFlow'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'

const tenantGastronomyRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  gastronomyRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent {...props} hasMoveInDate={true} screenTooltipKey='tooltip.screens.costs.allRent' />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => <Description {...props} hasLocationNote={true} />,
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[MultimediaUploaderType.PICTURE, MultimediaUploaderType.VIDEO]}
      />
    ),
  },
  gastronomyRentOtherFacilitiesScreen,
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} />,
  },
]

export const tenantGastronomyRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.tenant',
    estateType: 'wizard.navigation.header.gastronomy',
    path: TENANT_GASTRONOMY_RENT_FLOW_PATH,
    name: FlowName.TENANT_GASTRONOMY_RENT,
    validationSchema: tenantGastronomyRentSchema,
    options: {
      hasTextSuggestions: true,
    },
    metaData: {
      category: RealEstateCategory.GASTRONOMY,
      segmentation: SegmentationType.TENANT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: {
    hideStreetAndStreetNumber: false,
  },
  flowScreens: tenantGastronomyRentFlowScreens,
}
